const defaultButton = {
  id: 'close',
  class: 'btn-info',
  eventName: 'event-close-button-pressed',
  text: 'Закрыть'
}

export default {
  defaultButton: defaultButton,
  closeButton: defaultButton,
  blockedSignAndSend: {
    id: 'signAndSend',
    class: 'btn-success button-in-widget--loading',
    disabled: true,
    text: '\u00A0'
  },
  signAndSend: {
    id: 'signAndSend',
    class: 'btn-success',
    eventName: 'event-sign-and-send-button-pressed',
    text: 'Подписать и отправить'
  }
}
